import { useEffect, useState } from "react";
import { getAddresses, deleteAddress } from "../services/addressService";
import AddressModal from "./AddressModal";
import { ChevronDown,Plus,ChevronLeft } from "lucide-react";
import AddressCard from "./AddressCard/AddressCard";
import noOrderImage from "../assets/images/fav.avif";
import DashboardAddressSkeleton from "./Dashboard/Skeleton/Address/DashboardAddressSkeleton";

export default function DashboardAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [form, setForm] = useState({
    name: "",
    lname: "",
    provinceId: "",
    cityId: "",
    postalCode: "",
    mobile: "",
    address: "",
  });

  const [visibleCount, setVisibleCount] = useState(10);
  const [loading, setLoading] = useState(true);

  const fetchAddresses = () => {
    setLoading(true);
    getAddresses().then((data) => {
      setAddresses(data);
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const showMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  const visibleAddresses = addresses.slice(0, visibleCount);

    useEffect(() => {
    const img = new Image();
    img.src = "/images/fav.avif";
  }, []);

  // if (loading) {
  //   return (
  //     <div className="loader-wrapper">
  //       <div className="loading">
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //         <span></span>
  //       </div>
  //     </div>
  //   );
  // }

   if (loading) {
      return <DashboardAddressSkeleton  />;
    }

  return (
    <div className="wrapper">
      <h2>
        <span>آدرس های من</span>
      </h2>
 


      <div className="address-list">
        {visibleAddresses.length === 0 ? (
          <div className="orderNone">
       <p>لیست آدرس های شما خالی است</p>
          <div>
            <img src={noOrderImage} alt="No active wishlist" />
          </div>
        </div>
        ) : (
          visibleAddresses.map((address) => (
            <AddressCard
              key={address.id}
              address={address}
              refreshList={fetchAddresses}
              onDelete={deleteAddress}
            />
          ))
        )}

        <div className="wrapper-footer">
          {addresses.length > visibleCount && (
            <button onClick={showMore} className="show-more-btn">
              نمایش بیشتر
              <ChevronDown color="#95b73c" />
            </button>
          )}
        </div>

        <div className="add-address-profile"       onClick={() => {
            setForm({
              name: "",
              lname: "",
              provinceId: "",
              cityId: "",
              postalCode: "",
              mobile: "",
              address: "",
            });

            setShowAddressModal(true);
          }}>       
         <span className="add-address-right">
    
          <Plus className="plus-icon" color="#424750" />
          <span className="add-address-title">
              اضافه کردن آدرس جدید      
          </span>
               
           
         </span>
            <span className="icon-chevronLeft">
              <ChevronLeft className="icon-chevronLeft" color="#424750" />
            </span>
        </div>
      

        {showAddressModal && (
          <AddressModal
            form={form}
            setForm={setForm}
            onSave={fetchAddresses}
            onClose={() => setShowAddressModal(false)}
          />
        )}
      </div>
    </div>
  );
}
